import { twMerge } from "tailwind-merge";

import { Icon, H5 } from "@sellar-io/components";
import { ProfilePicture } from "../profilePicture/ProfilePicture";

export const NotificationGroupContent = ({
  markAsRead,
  isNotificationPopover,
  logoUrl,
  senderBusinessName,
  children,
  title,
  description,
  isNotificationRead,
}: {
  markAsRead: () => void;
  isNotificationPopover: boolean;
  logoUrl: string | null;
  senderBusinessName: string;
  children?: React.ReactNode;
  title: string;
  description: string | null;
  isNotificationRead: boolean;
}) => {
  return (
    <div
      onClick={markAsRead}
      className={twMerge(
        `inline-flex w-full max-w-full cursor-pointer items-center justify-start gap-4 self-stretch overflow-hidden bg-white p-4`,
        isNotificationPopover && "border-b",
      )}
    >
      <div className="relative h-12 w-12">
        <ProfilePicture
          size={"large"}
          logoUrl={logoUrl}
          name={senderBusinessName}
        />

        {children}
      </div>
      <div className="inline-flex flex-1 flex-col items-start justify-start">
        <H5 className="line-clamp-2 text-base leading-normal font-semibold text-zinc-800">
          {title}
        </H5>
        <div className="line-clamp-2 text-sm leading-tight font-normal text-zinc-700">
          {description}
        </div>
      </div>
      <div className="flex items-center justify-start gap-2">
        {!isNotificationRead && (
          <div className="relative h-2 w-2 rounded-xl bg-red-600" />
        )}
        <div className="flex-end flex">
          <Icon icon={"CHEVRON_RIGHT"} />
        </div>
      </div>
    </div>
  );
};
